export const ENTERPRISE_CREATIVES_BUFFER_NONE_VALUE = "none";
